import "./polyfills";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {appRef, VisBosModule} from "./app/";
import {environment} from "./environments/environment";
import {enableProdMode} from "@angular/core";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(VisBosModule)
  .then((_appRef) => {
    appRef(_appRef);
  });




// WEBPACK FOOTER //
// ./src/main.ts